import { QuestionIcon } from '@eleveo/icons-react';
import { Tooltip } from '@zoom/components';
import { TFunction } from 'i18next';
import debounce from 'lodash.debounce';
import React, { useState, Dispatch, useEffect } from 'react';
import { Label } from 'reactstrap';

import { RangeSlider } from '../../../components/RangeSlider/RangeSlider';
import { getPrioritizeSelectorPropTag } from '../constants';
import { AutoScheduleOptions } from '../types';

interface PrioritizeSelectorProps {
  disabled?: boolean;
  hintMessage: string;
  id: keyof AutoScheduleOptions;
  label: string;
  setValue: Dispatch<number>;
  t: TFunction;
  value: number;
}

export const PrioritizeSelector: React.FC<PrioritizeSelectorProps> = ({
  disabled = false,
  hintMessage,
  id,
  label,
  setValue,
  t,
  value,
}) => {
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    if (value !== currentValue) {
      setCurrentValue(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const debouncedSetValue = debounce(setValue, 2);

  const onChangeHandler = (values: ReadonlyArray<number>) => debouncedSetValue(values[0]);
  const onUpdateHandler = (values: ReadonlyArray<number>) => setCurrentValue(values[0]);

  return (
    <div className="prioritize-range-selector__wrapper">
      <Tooltip message={hintMessage} placement="auto">
        <QuestionIcon className="text-chart-300 text-xl" />
      </Tooltip>
      <Label className="prioritize-range-selector__label" data-test-id={getPrioritizeSelectorPropTag(id, 'label')}>
        {label}
      </Label>
      <RangeSlider
        dataTestId={getPrioritizeSelectorPropTag(id, 'input')}
        disabled={disabled}
        domain={[0, 10]}
        onChange={onChangeHandler}
        onUpdate={onUpdateHandler}
        values={[currentValue]}
      />
      <Label className="prioritize-range-selector__values-labels__wrapper">
        <span>{t('schedule.autoSchedule.low')}</span>
        <span>{t('schedule.autoSchedule.medium')}</span>
        <span>{t('schedule.autoSchedule.high')}</span>
      </Label>
    </div>
  );
};
